module.exports = __webpack_public_path__ + "static/media/31-4.1e0fe689.mp3";